import { useState } from "react";
import type { FC } from "react";
import { ToggleButton } from "react-bootstrap";

import { BookmarkedModal } from "components/Modal/Bookmarked";

import BookmarkIcon from "images/icons/bookmark.svg";

import { useBookmarks } from "utils/hooks/useBookmarks";

interface Props {
  className?: string;
  userAssignmentId: string;
}

const BookmarkIconAsButton: FC<Props> = ({ className, userAssignmentId }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const { toggleBookmark, isBookmarked, isLoadingData } = useBookmarks(userAssignmentId);

  const handleButtonClick = () => {
    if (isLoadingData) return;

    toggleBookmark();
    if (!isBookmarked) {
      setModalVisible(true);
    }
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  return (
    <>
      <ToggleButton
        type="checkbox"
        variant="select"
        value="test"
        checked={isBookmarked}
        className={`btn-xl btn-shadow bookmark-button ${className ?? ""}`}
        onClick={handleButtonClick}
        id={`${userAssignmentId}-bookmark`}
      >
        <BookmarkIcon fill="none" />
      </ToggleButton>
      {modalVisible ? <BookmarkedModal isLoading={isLoadingData} onClose={handleModalClose} /> : null}
    </>
  );
};

export default BookmarkIconAsButton;
